import _ from "lodash";
import { ll } from "../core/ll";
import { user } from "../core/user";

/*
* clearValidation
* Clear validation on a given container
*
*/
export function clearValidation(container) {
    if ($.type(container) == "string") {
        container = $(container);
    }
    var requiredElems = container.find("[required]");

    $.each(requiredElems, function (index, input) {
        input = $(input);
        var data = input.data && input.data();
        var element = input;
        if (data) {
            $.each(data, function (index2, value) {
                if (value && value.wrapper) {
                    element = value.wrapper;
                    return false;
                }
                return true;
            });
        }

        element.removeClass("validation-failure");
    });
}

function getUDFName(UDFName: string) {
    var results = _.find(user.companyData.UserDefinedFields, a => {
        if (a.BindName.toLowerCase() == UDFName.toLowerCase()) {
            return true;
        }
    });
    return results.FieldName;
}

export function buildValidationMessage(args) {
    var message = "Validation Error.";
    if (args) {
        message = "";
        var name;
        var i;
        var index;
        if (args.nan && !$.isEmptyObject(args.nan)) {
            message += "<div class='alert-section'><span class='alert-header'>" + ll("NanValidationIssues") + "</span></div>";
            var nans = Object.keys(args.nan);
            for (i = 0; i < nans.length; i++) {
                name = nans[i];
                let llName = ll(name);
                var localizedUDFName;
                if (!llName && name.indexOf("UDF_") > 0) {
                    llName = getUDFName(name);
                }

                index = name.lastIndexOf("_");
                if (index != -1) {
                    name = name.substring(index + 1);
                }

                var nan = args.nan[name] || ll("NotANumber").format(llName);
                message += "<div class='alert-sub-section'><span class='alert-header'>" + llName + "</span> " + nan + "</div>";
            }
        }
        if (args.minRange && !$.isEmptyObject(args.minRange)) {
            message += "<div class='alert-section'><span class='alert-header'>" + ll("MinRangeValidationIssues") + "</span></div>";
            var minRanges = Object.keys(args.minRange);
            for (i = 0; i < minRanges.length; i++) {
                name = minRanges[i];
                let llName;
                if (name.indexOf("UDF_") > -1) {
                    llName = ll(name, "", false);
                    if (llName == "Not Localized String") {
                        llName = getUDFName(name);
                    }
                } else {
                    llName = ll(name);
                }

                index = name.lastIndexOf("_");
                if (index != -1) {
                    name = name.substring(index + 1);
                }

                var minRange = args.minRange[name] || ll("MinimumMessage").format(llName);
                message += "<div class='alert-sub-section'><span class='alert-header'>" + llName + "</span> " + minRange + "</div>";
            }
        }
        if (args.maxLength && !$.isEmptyObject(args.maxLength)) {
            message += "<div class='alert-section'><span class='alert-header'>" + ll("MaxLengthValidationIssues") + "</span></div>";
            var maxLengths = Object.keys(args.maxLength);
            for (i = 0; i < maxLengths.length; i++) {
                name = maxLengths[i];
                var maxLength = args.maxLength[name];

                let llName;
                if (name.indexOf("UDF_") > -1) {
                    llName = ll(name, "", false);
                    if (llName == "Not Localized String") {
                        llName = getUDFName(name);
                    }
                } else {
                    llName = ll(name);
                }

                index = name.lastIndexOf("_");
                if (index != -1) {
                    name = name.substring(index + 1);
                }

                message += "<div class='alert-sub-section'><span class='alert-header'>" + llName + "</span> " + maxLength + "</div>";
            }
        }
        if (args.required && !$.isEmptyObject(args.required)) {
            message += "<div class='alert-section'><span class='alert-header'>" + ll("RequiredValidationIssues") + "</span></div>";
            var requireds = Object.keys(args.required);
            for (i = 0; i < requireds.length; i++) {
                name = requireds[i];
                index = name.lastIndexOf("_");
                if (index != -1) {
                    name = name.substring(index + 1);
                }

                message += "<div class='alert-sub-section'>" + name + "</div>";
            }
        }
        if (args.invalid && !$.isEmptyObject(args.invalid)) {
            message += "<div class='alert-section'><span class='alert-header'>" + ll("InvalidValidationIssues") + "</span></div>";
            var invalids = Object.keys(args.invalid);
            for (i = 0; i < invalids.length; i++) {
                name = invalids[i];
                let llName;
                if (name.indexOf("UDF_") > -1) {
                    llName = ll(name, "", false);
                    if (llName == "Not Localized String") {
                        llName = getUDFName(name);
                    }
                } else {
                    llName = ll(name);
                }

                index = name.lastIndexOf("_");
                if (index != -1) {
                    name = name.substring(index + 1);
                }

                var invalid = args.invalid[name] || ll("IsInvalidMessage").format(ll(name));
                message += "<div class='alert-sub-section'><span class='alert-header'>" + llName + "</span> " + invalid + "</div>";
            }
        }
        if (args.pattern && !$.isEmptyObject(args.pattern)) {
            message += "<div class='alert-section'><span class='alert-header'>" + ll("PatternValidationIssues") + "</span></div>";
            var patterns = Object.keys(args.pattern);
            for (i = 0; i < patterns.length; i++) {
                name = patterns[i];
                index = name.lastIndexOf("_");
                if (index != -1) {
                    name = name.substring(index + 1);
                }

                message += "<div class='alert-sub-section'>" + name + "</div>";
            }
        }
        if (args.customMessage) {
            message += "<div class='alert-section'><span class='alert-header'>" + args.customMessage + "</span></div>";
        }
    }
    return message;
}
